import React from 'react';
import PropTypes from 'prop-types';

import { ButtonList } from 'wsm-vehicle-cta-display';
import { useRequestData } from 'wsm-common-data';
import { useDRClickHandler } from '../../hooks/useDRClickHandler';

const CTAButtonList = ({ targetLocations, buttons }) => {
	const { windowId } = useRequestData();
	const handleDRClick = useDRClickHandler();

	const processedButtons = buttons?.map((button) => {
		const newButton = { ...button };
		newButton.btnAttributes = { ...button.btnAttributes };

		if (
			newButton.btnAttributes &&
			typeof newButton.btnAttributes.onClick === 'string'
		) {
			/* eslint-disable-next-line no-new-func */
			newButton.btnAttributes.onClick = new Function(
				'element',
				newButton.btnAttributes.onClick
			);
		}

		const originalOnClick = newButton.btnAttributes?.onClick;
		newButton.btnAttributes = {
			...newButton.btnAttributes,
			onClick: (event) => {
				handleDRClick(event, button);
				if (originalOnClick && typeof originalOnClick === 'function') {
					originalOnClick(event?.target);
				}
			}
		};

		return newButton;
	});

	return (
		<>
			{/* ePrice portal container for ws-detailed-pricing to insert ePrice button. */}
			{windowId === 'vehicle-ctas1' && (
				<div
					className="eprice-react-portal"
					data-testid="eprice-portal"
					data-target-locations={[...targetLocations].join(' ')}
				/>
			)}
			<ButtonList
				buttons={processedButtons}
				dataLocation={targetLocations}
			/>
		</>
	);
};

export default CTAButtonList;

CTAButtonList.propTypes = {
	targetLocations: PropTypes.instanceOf(Set).isRequired,
	buttons: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
